import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { ECode, EGroup } from '../../../../services/reports';

interface ISurvey {
  share: number;
  name: string;
}

interface IData {
  code: ECode;
  group: EGroup;
  surveys: ISurvey[];
  category: {
    code: ECode;
    description: string;
    title: string;
  };
}

interface IXAxisLabel {
  data: IData[];
  angle: number;
  x: number;
  y: number;
  width: number;
  payload: { value: string };
}

const XAxisLabel: FC<IXAxisLabel> = ({ width, data }) => {
  const theme = useTheme();
  const paddingRight = 40;
  const labelWidth = (width - paddingRight) / data.length;

  return (
    <g transform="translate(40, 0)">
      {data.map((item, index) => (
        <foreignObject key={item.code} x={index * labelWidth} y={0} width={labelWidth} height={60}>
          <div
            style={{
              width: `${labelWidth}px`,
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 500,
              color: theme.colors.neutral.primary[60],
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {item.category.title}
          </div>
        </foreignObject>
      ))}
    </g>
  );
};

export default XAxisLabel;
